import { render, staticRenderFns } from "./VmcContainer.vue?vue&type=template&id=86ada426&"
import script from "./VmcContainer.vue?vue&type=script&lang=js&"
export * from "./VmcContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports